import { render, staticRenderFns } from "./LiveGuideDetail.vue?vue&type=template&id=d233831e&scoped=true"
import script from "./LiveGuideDetail.vue?vue&type=script&lang=js"
export * from "./LiveGuideDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveGuideDetail.vue?vue&type=style&index=0&id=d233831e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d233831e",
  null
  
)

export default component.exports